import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), origin: window.location.origin });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div data-testid="forgot-password-sent" className="pt-32 pb-24 min-h-screen fade-in">
        <div className="max-w-md mx-auto px-6 text-center">
          <div className="w-16 h-16 mx-auto bg-[#C6FF33] border-2 border-[#121212] flex items-center justify-center">
            <MailCheck size={26} className="text-[#121212]" />
          </div>
          <h1 className="font-serif text-4xl text-stone-900 mt-6">Check your inbox.</h1>
          <p className="mt-3 text-stone-600">
            If an account exists for <b>{email}</b>, we've sent a link to reset your password. It's valid for 1 hour.
          </p>
          <p className="mt-2 text-sm text-stone-500">Don't see it? Check your spam folder, or try again in a moment.</p>
          <Link to="/login" className="mt-8 inline-block text-sm text-[#121212] hover:underline">Back to sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="forgot-password-page" className="pt-32 pb-24 min-h-screen fade-in">
      <div className="max-w-md mx-auto px-6">
        <h1 className="font-serif text-5xl text-stone-900">Forgot password?</h1>
        <p className="mt-2 text-stone-600">Enter your email and we'll send you a link to reset it.</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">Email</label>
            <input
              data-testid="forgot-email"
              type="email" required autoFocus
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] focus:border-[#121212] focus:outline-none focus:ring-2 focus:ring-[#121212]/20"
            />
          </div>
          <button
            data-testid="forgot-submit"
            disabled={busy}
            className="w-full px-6 py-4 bg-[#121212] text-[#F2E9D8] hover:bg-black text-xs tracking-[0.25em] uppercase font-bold disabled:opacity-40 transition-all"
          >
            {busy ? "Sending…" : "Send reset link"}
          </button>
        </form>
        <p className="mt-6 text-sm text-stone-600 text-center">
          Remembered it? <Link to="/login" className="text-[#121212] hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
